import memoize from 'lodash.memoize';
import { getGPUData } from './getGpuData';

type GPUTierConfig =
  | number
  | {
      min?: number; // The minimum disallowed tier and higher (inclusive)
      max?: number; // The maximum disallowed tier and lower (exclusive)
    };

type DeviceConfig = {
  gpuTier?: GPUTierConfig;
};

/**
 * Config for devices for which animation should be disabled
 */
const AnimationDisabledDeviceConfig: DeviceConfig = {
  gpuTier: { max: 1 },
};

/**
 * Checks whether animation should be disabled for the device based on a passed config
 * @param config {DeviceConfig} - config for devices for which animation should be disabled
 * @returns {Promise<boolean>}
 */
export const shouldDisableAnimationImpl = async (
  config: DeviceConfig,
): Promise<boolean> => {
  const { tier: gpuTier } = await getGPUData();

  if (typeof config.gpuTier === 'number') {
    return gpuTier === config.gpuTier;
  } else if (
    (config.gpuTier?.min !== undefined && config.gpuTier.min <= gpuTier) ||
    (config.gpuTier?.max !== undefined && config.gpuTier.max >= gpuTier)
  ) {
    return true;
  }

  return false;
};

/**
 * Checks whether animation should be disabled for the device
 * based on AnimationDisabledDeviceConfig
 * @returns {Promise<boolean>} - Memoized value
 */
export const shouldDisableAnimation: () => Promise<boolean> = memoize(
  async () => shouldDisableAnimationImpl(AnimationDisabledDeviceConfig),
);
